/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InfantTwoYearOld } from './InfantTwoYearOld';
import {
    InfantTwoYearOldFromJSON,
    InfantTwoYearOldFromJSONTyped,
    InfantTwoYearOldToJSON,
} from './InfantTwoYearOld';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface InfantTwoYearOldPagination
 */
export interface InfantTwoYearOldPagination {
    /**
     * 
     * @type {Array<InfantTwoYearOld>}
     * @memberof InfantTwoYearOldPagination
     */
    data?: Array<InfantTwoYearOld>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof InfantTwoYearOldPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the InfantTwoYearOldPagination interface.
 */
export function instanceOfInfantTwoYearOldPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InfantTwoYearOldPaginationFromJSON(json: any): InfantTwoYearOldPagination {
    return InfantTwoYearOldPaginationFromJSONTyped(json, false);
}

export function InfantTwoYearOldPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InfantTwoYearOldPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(InfantTwoYearOldFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function InfantTwoYearOldPaginationToJSON(value?: InfantTwoYearOldPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(InfantTwoYearOldToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

